import React, { useState, useRef, useEffect, useId } from 'react';
import { Col, Text, TouchField, Tooltip } from 'components';
import { useNavFunc } from 'navigation';
import { COLOR } from 'const';
import RequestUtils from 'store/api-client/Request.utils';

const SideNav = ({ title, screen, highlights, params, tooltip, icon, url, badge, externalUrl }) => {
  const { navigate, route, navigation } = useNavFunc();
  const [isHover, setIsHover] = useState(false);
  const [id] = useState('item-'+Math.random().toString(36).substring(7));
  const isActive = route.name === screen || (!!highlights && highlights.includes(route.name));
  const bgColor = isActive ? COLOR.MAIN : (
    isHover ? COLOR.GREY_LIGHT : 'transparent'
  );
  const textColor = isActive ? 'white' : 'black';
  useEffect(() => {
    const navItem = document.getElementById(id);
    navItem.onclick = (e) => {
      e.preventDefault();
      if (externalUrl) {
        const mCentralUrl = RequestUtils.host === 'https://msc.personify.tech' 
        ? 'https://mcentral.fm/' 
        : 'https://msc-customers.vercel.app/'
        let href = externalUrl.startsWith('http') ? externalUrl : `${mCentralUrl}${externalUrl}`;
        href = href + `?token=${encodeURIComponent(RequestUtils.getToken())}`
        window.location.href = href;
        return;
      }
      navigate(screen, params);
    };
  }, [id, screen, params, externalUrl]);

  const renderNavItem = () => {
    // @ts-ignore
    return (<nav-item
      active={isActive ? 'active' : ''}
      icon={icon}
      title={title}
      url={url}
      id={id}
      badge={badge}
    />)
  }

  return (
    <Col mv0 mh1 mh0
      // onPress={(e) => {
      //   e.stopPropagation();
      //   navigate(screen, params);
      // }}
    >
      {tooltip ? (
        <Tooltip
          title={tooltip}
          trigger="mouseenter"
          position="top-end"
        >
          {renderNavItem()}
        </Tooltip>
      ) : (
        renderNavItem()
      )}
    </Col>
  );
};

export default SideNav;
